import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileDownload, faPaperclip } from '@fortawesome/pro-solid-svg-icons'
import { useDispatch } from 'react-redux'
import * as fromActions from 'store/actions/user.action'
import Button from 'design-system/button'
import { ButtonSizes, ButtonVariant } from 'design-system/button/src/Button'
import styles from './UploadButton.module.scss'

interface IProps {
  show: boolean
  setShow: (state: boolean) => void
}

const UploadButton: React.FC<IProps> = ({ show, setShow }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleClose = () => setShow(false)

  const handleFileUpload = (e: any) => {
    const [file] = e.target.files
    dispatch({ type: fromActions.USER_UPLOAD, payload: file })
    setShow(false)
  }

  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose} centered>
        <Modal.Header
          translate="yes"
          closeButton
          className="ml-3 mr-3 mt-2 pb-2"
        >
          <Modal.Title>
            <p className={styles.headFont}>
              {t('configuration.users.upload.modal.titleNew')}
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="ml-3 mr-3">
          <p>{t('configuration.users.upload.modal.legendNew')}</p>
          <Modal.Dialog size="lg" className="pt-1 mb-2">
            <Form className={styles.inputDesing}>
              <Form.Group>
                <input
                  className={styles.inputfile}
                  id="customFile"
                  type="file"
                  onChange={handleFileUpload}
                />
                <Form.Label htmlFor="customFile" className={styles.desiNG}>
                  <FontAwesomeIcon icon={faPaperclip} />{' '}
                  {t('configuration.users.upload.modal.addFile')}
                </Form.Label>
              </Form.Group>
            </Form>
          </Modal.Dialog>
          <div className="float-right">
            <a
              className={styles.bodyFont}
              target="_blank"
              href={
                'https://rankmi-lms-prod.s3.us-east-1.amazonaws.com/templates/asignacion-perfiles-a-usuarios.xlsx'
              }
            >
              <span>{t('configuration.users.upload.modal.template')}</span>
              <FontAwesomeIcon
                icon={faFileDownload}
                className="mt-2 ml-2"
              ></FontAwesomeIcon>
            </a>
          </div>
        </Modal.Body>
        <Modal.Footer className="ml-3 mr-3 mt-2">
          <Button
            variant={ButtonVariant.Secondary}
            size={ButtonSizes.Small}
            onClick={handleClose}
          >
            {t('commons.buttons.close')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default UploadButton
